var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44958 11H4.68881L4.91274 8.8H7.15161L6.92768 11H9.16692L9.39084 8.8H11.1832L11.4071 6.6H9.61476L9.83867 4.4002H12.3033L12.5272 2.2002H10.0626L10.2865 0H8.0473L7.82336 2.2002H5.58449L5.80843 0H3.5692L3.34525 2.2002H1.55498L1.33105 4.4002H3.12133L2.89743 6.6H0.434861L0.210938 8.8H2.6735L2.44958 11ZM5.36056 4.4002L5.13666 6.6H7.37553L7.59943 4.4002H5.36056Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.13f3376b9448e4187885771dc984883f.svg";
export { ForwardRef as ReactComponent };